module.exports = __webpack_public_path__ + "static/media/pimm.17ef4fd9.jpg";